import styled from 'styled-components';
import { Table, Tr, Td, Th, Icon } from 'next/components/ui';

export const ActivitiesTable = styled(Table)`
  ${Tr}:nth-child(10) {
    ${Td} {
      border-bottom: none;
    }
  }
  ${Th}:nth-child(1), ${Th}:nth-child(2) , ${Th}:nth-child(4) {
    width: 20%;
  }
  ${Th}:nth-child(3) {
    width: 40%;
  }
`;

export const ActivitiesRow = styled(Tr)`
  ${Td} {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 300px;
  }
`;

export const Filters = styled.div`
  display: flex;

  > *:not(:last-child) {
    margin-right: 1em;
  }
`;

export const ActionIcon = styled(Icon)`
  font-size: var(--small);
  color: ${props => `var(--activity-${props.$action}-color)`};
`;

export const Action = styled.span``;

export const ActionLabel = styled.div`
  display: flex;
  align-items: center;

  > *:not(:first-child) {
    margin-left: 8px;
  }
`;
